import { performanceInformant } from "../performanceInformant";

performanceInformant();
